<div class="modal-header">
  <h4 class="modal-title">{{'ALARMS_TITLE' | translate}} {{mode | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<div class="modal-body formModal" *ngIf="!readOnly">
  <mat-horizontal-stepper [linear]="true" #stepper>

    <mat-step [stepControl]="alarmsTypeForm">

      <form [formGroup]="alarmsTypeForm">
        <ng-template matStepLabel>{{'ALARMS_TYPE'|translate}}</ng-template>

        <div class="deviceTypeFilter" placement="top"
             [ngbTooltip]="'ALARMS_TYPE_CHIPS' | translate">

          <mat-chip-list>
            <mat-chip *ngFor="let alarmType of alarmsTypes index as i "
                      [ngClass]="{'selected' : alarmType.name === alarmTypeSelected}"
                      (click)="setAlarmType(alarmType.name)">
              {{alarmType.name | translate}}
            </mat-chip>
          </mat-chip-list>

        </div>
        <br clear="left"/>

        <mat-form-field>
          <input matInput [placeholder]="'NAME' | translate" formControlName="name" required>
          <mat-error *ngIf="name.invalid">{{getErrorMessageName()}}</mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step *ngIf="alarmTypeSelected === ALARM_TYPE.OPERATING">
      <ng-template matStepLabel>{{'ALARMS_PARAM_BY_TYPE'|translate}}</ng-template>


      <mat-form-field>
        <mat-select [placeholder]="'DEVICE_TYPE' | translate" required [(value)]="opParamsDeviceType">
          <mat-option [value]="deviceType.id"
                      *ngFor="let deviceType of DEVICE_TYPES_FOR_ALARMS">{{deviceType.key| translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select [placeholder]="'STARTING_MODE' | translate" required [(value)]="opParamsStartingMode">
          <mat-option [value]="'first-measure'">{{'first-measure'| translate}}</mat-option>
          <mat-option [value]=" 'init-date'">{{ 'init-date' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="date-picker" placement="bottom"
                      [ngbTooltip]="'START_DATE_TOOLTIP' | translate">
        <input [formControl]="date" matInput [(value)]="dateStart" [matDatepicker]="picker1" required
               placeholder="Start">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1 [startAt]="dateStart"></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="float-left">
        <mat-select [placeholder]="'REMINDER_INTERVAL' | translate" required
                    [(value)]="opParamsReminderInterval">
          <mat-option *ngFor="let reminderInterval of reminderIntervals"
                      [value]="reminderInterval.name">{{reminderInterval.value}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="opParamsDeviceType !== 1">
        <mat-select [placeholder]="'PERIOD' | translate" required [(value)]="opParamsPeriod">
          <mat-option *ngFor="let v of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]"
                      [value]="v">{{v}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-slide-toggle class="sliderActiveList" [(ngModel)]="opParamsActive"
                        placement="right"
                        [ngbTooltip]="'ACTIVE' | translate">{{'ACTIVE' | translate}}
      </mat-slide-toggle>
      <br clear="left"/>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>
    <mat-step *ngIf="alarmTypeSelected === ALARM_TYPE.DATA_USAGE" [stepControl]="alarmsDataUsageForm">
      <form [formGroup]="alarmsDataUsageForm">
        <ng-template matStepLabel>{{'ALARMS_PARAM_BY_TYPE'|translate}}</ng-template>

        <mat-form-field>
          <input formControlName="period" matInput [placeholder]="'PERIOD_FOR_USAGE_ALARM' | translate" required
                 [(ngModel)]="usDaysInterval">
          <mat-error *ngIf="period.invalid">{{'VALUE_FORM_REQUIRED_NUMERICAL' | translate}}</mat-error>
        </mat-form-field>


        <mat-form-field>
          <input matInput formControlName="volume" [placeholder]="'VOLUME_MO_USAGE' | translate" required
                 [(ngModel)]="usMoUsage">
          <mat-error *ngIf="volume.invalid">{{'VALUE_FORM_REQUIRED_NUMERICAL' | translate}}</mat-error>
        </mat-form-field>

        <mat-slide-toggle [(ngModel)]="usParamsActive" formControlName="active"
                          placement="right"
                          [ngbTooltip]="'ACTIVE' | translate">{{'ACTIVE' | translate}}
        </mat-slide-toggle>
        <br clear="left"/>
      </form>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>


    </mat-step>
    <mat-step *ngIf="alarmTypeSelected === ALARM_TYPE.THRESHOLD">
      <ng-template matStepLabel>{{'ALARMS_PARAM_BY_TYPE'|translate}}</ng-template>
      <mat-slide-toggle class="sliderActiveList" [(ngModel)]="low"
                        placement="right"
                        [ngbTooltip]="'LOW' | translate">{{'LOW' | translate}}
      </mat-slide-toggle>
      <mat-slide-toggle class="sliderActiveList" [(ngModel)]="medium"
                        placement="right"
                        [ngbTooltip]="'MEDIUM' | translate">{{'MEDIUM' | translate}}
      </mat-slide-toggle>
      <mat-slide-toggle class="sliderActiveList" [(ngModel)]="high"
                        placement="right"
                        [ngbTooltip]="'HIGH' | translate">{{'HIGH' | translate}}
      </mat-slide-toggle>
      <br clear="left"/>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step *ngIf="alarmTypeSelected === ALARM_TYPE.CONSOLIDATED_EVENT_DYN" [stepControl]="alarmsConsolidatedEventDynForm">
      <form [formGroup]="alarmsConsolidatedEventDynForm">
        <ng-template matStepLabel>{{'ALARMS_PARAM_BY_TYPE'|translate}}</ng-template>
        <mat-form-field>
          <input formControlName="range" matInput [placeholder]="'RANGE' | translate" required
                 [(ngModel)]="event_dyn_range">
                  <mat-error *ngIf="range.invalid">{{'VALUE_FORM_REQUIRED_FLOAT' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="events" matInput [placeholder]="'N_EVENTS' | translate" required
                 [(ngModel)]="event_dyn_events">
                  <mat-error *ngIf="events.invalid">{{'VALUE_FORM_REQUIRED_NUMERICAL' | translate}}</mat-error>
        </mat-form-field>
        <br clear="left"/>
      </form>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step *ngIf="alarmsWithGenericParams.includes(alarmTypeSelected)">
      <ng-template matStepLabel>{{'ALARMS_PARAM_BY_TYPE'|translate}}</ng-template>
      <app-project-alarm-parameters
        [alarmName]="alarmTypeSelected"
        [params]="alarmGenericParams"
        [alarmId]="alarmId"
        [projectId]="projectId"
        [changeVueObservable]="stepper.selectionChange"
        (updateValue)="alarmGenericParams = $event"
        (invalidFields)="invalidFields = $event"
        (next)="stepper.next()"
        (back)="stepper.previous()">
      </app-project-alarm-parameters>
    </mat-step>

    <!-- Alarm locations stepper -->
    <mat-step *ngIf="alarmTypesWithLocations.includes(alarmTypeSelected)">
      <ng-template matStepLabel>{{'ALARMS_LOCATIONS'|translate}}</ng-template>
      <app-project-alarms-location-remove-list *ngIf="showSpinner===false"
                                               [alarmLocationsList]="alarmLocationsList"
                                               [typeAlarm]="alarmTypeSelected" [projectId]="projectId"
                                               [locationDeviceType]="opParamsDeviceType"
                                               #masterLocation
      ></app-project-alarms-location-remove-list>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step>
      <ng-template matStepLabel>{{'ALARMS_USERS'|translate}}</ng-template>
      <app-project-alarms-user-remove-list *ngIf="showSpinner===false"
                                           [alarmUsersList]="alarmUsersList"
                                           #masterUser></app-project-alarms-user-remove-list>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step *ngIf="alarmIsValidable()">
      <ng-template matStepLabel>{{'ALARMS_VALIDATORS'|translate}}</ng-template>
      <app-project-alarms-user-remove-list *ngIf="showSpinner===false"
                                           [alarmUsersList]="alarmValidatorsList" [validatorMode]="true"
                                           #masterValidator></app-project-alarms-user-remove-list>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step>
      <ng-template matStepLabel>{{'CHECK_SAVE'|translate}}</ng-template>

      <b>{{'ALARMS_TYPE'|translate}}</b>
      <br clear="left"/>
      <mat-chip>
        {{alarmTypeSelected | translate}}
      </mat-chip>
      <mat-form-field>
        <input matInput [placeholder]="'NAME' | translate" [value]="alarmsTypeForm.value.name" required
               disabled>
      </mat-form-field>
      <br clear="left"/>
      <div *ngIf="alarmTypeSelected ===  ALARM_TYPE.OPERATING">
        <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
        <br clear="left"/>
        <mat-form-field>
          <mat-select [placeholder]="'DEVICE_TYPE' | translate" required [(value)]="opParamsDeviceType"
                      disabled>
            <mat-option [value]="deviceType.id"
                        *ngFor="let deviceType of DEVICE_TYPES_FOR_ALARMS">{{deviceType.key | translate}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select [placeholder]="'STARTING_MODE' | translate" required [(value)]="opParamsStartingMode"
                      disabled>
            <mat-option [value]="'first-measure'">{{'first-measure'| translate}}</mat-option>
            <mat-option [value]=" 'init-date'">{{ 'init-date' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="date-picker" placement="bottom"
                        [ngbTooltip]="'START_DATE_TOOLTIP' | translate">
          <input matInput [value]="date.value" [matDatepicker]="picker2" required disabled
                 placeholder="Start">
        </mat-form-field>

        <mat-form-field class="float-left">
          <mat-select [placeholder]="'REMINDER_INTERVAL' | translate" required
                      [(value)]="opParamsReminderInterval" disabled>
            <mat-option *ngFor="let reminderInterval of reminderIntervals"
                        [value]="reminderInterval.name">{{reminderInterval.value}}</mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field *ngIf="opParamsDeviceType !== 1">
          <mat-select [placeholder]="'PERIOD' | translate" required [(value)]="opParamsPeriod" disabled>
            <mat-option *ngFor="let v of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]"
                        [value]="v">{{v}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle class="sliderActiveList" [(ngModel)]="opParamsActive"
                          placement="right"
                          [ngbTooltip]="'ACTIVE' | translate" disabled>{{'ACTIVE' | translate}}
        </mat-slide-toggle>
        <br clear="left"/>
      </div>
      <div *ngIf="alarmTypeSelected === ALARM_TYPE.DATA_USAGE">
        <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
        <br clear="left"/>
        <mat-form-field>
          <input matInput [placeholder]="'PERIOD_FOR_USAGE_ALARM' | translate" required [(ngModel)]="usDaysInterval"
                 disabled>
        </mat-form-field>


        <mat-form-field>
          <input matInput [placeholder]="'VOLUME_MO_USAGE' | translate" required disabled
                 [(ngModel)]="usMoUsage">

        </mat-form-field>

        <mat-slide-toggle [(ngModel)]="usParamsActive" disabled
                          placement="right"
                          [ngbTooltip]="'ACTIVE' | translate">{{'ACTIVE' | translate}}
        </mat-slide-toggle>
        <br clear="left"/>
      </div>
      <div *ngIf="alarmTypeSelected === ALARM_TYPE.THRESHOLD">
        <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
        <br clear="left"/>
        <mat-slide-toggle class="sliderActiveList" [(ngModel)]="low"
                          placement="right"
                          [ngbTooltip]="'LOW' | translate" disabled>{{'LOW' | translate}}
        </mat-slide-toggle>
        <mat-slide-toggle class="sliderActiveList" [(ngModel)]="medium"
                          placement="right"
                          [ngbTooltip]="'MEDIUM' | translate" disabled>{{'MEDIUM' | translate}}
        </mat-slide-toggle>
        <mat-slide-toggle class="sliderActiveList" [(ngModel)]="high"
                          placement="right"
                          [ngbTooltip]="'HIGH' | translate" disabled>{{'HIGH' | translate}}
        </mat-slide-toggle>
        <br clear="left"/>
      </div>


      <div *ngIf="alarmTypeSelected === ALARM_TYPE.CONSOLIDATED_EVENT_DYN">
        <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
        <br clear="left"/>
        <mat-form-field>
          <input  matInput [placeholder]="'RANGE' | translate" [value]="event_dyn_range" required
                disabled>
        </mat-form-field>
        <mat-form-field>
          <input  matInput [placeholder]="'N_EVENTS' | translate" [value]="event_dyn_events" required
                 disabled>
        </mat-form-field>
        <br clear="left"/>
      </div>


      <div *ngIf="alarmsWithGenericParams.includes(alarmTypeSelected)">
        <app-project-alarm-parameters
          readOnly="true"
          [alarmName]="alarmTypeSelected"
          [params]="alarmGenericParams"
          [projectId]="projectId"
          [invalidFieldsArray]="invalidFields"
          (next)="alarmGenericParams = $event; stepper.next()"
          (back)="stepper.previous()">
        </app-project-alarm-parameters>
      </div>

      <div *ngIf="alarmTypesWithLocations.includes(alarmTypeSelected)">
        <b>{{'ALARMS_LOCATIONS'|translate}}</b>
        <br clear="left"/>
        <app-project-alarms-location-remove-list
          [alarmLocationsList]="masterLocation ? masterLocation.alarmLocationsList : alarmLocationsList"
          [projectId]="projectId" [typeAlarm]="alarmTypeSelected"
          [readOnly]="true"
          *ngIf="stepper._getFocusIndex() === getCheckSaveIndex() && showSpinner===false"
        ></app-project-alarms-location-remove-list>

      </div>
      <span>
      <b>{{'ALARMS_USERS'|translate}}</b>
      <br clear="left"/>
      <app-project-alarms-user-remove-list
        [alarmUsersList]="masterUser ? masterUser.alarmUsersList : alarmUsersList" [readOnly]="true"
        *ngIf="stepper._getFocusIndex() === getCheckSaveIndex() && showSpinner===false"
      ></app-project-alarms-user-remove-list>
      <br clear="left"/>
      </span>

      <span *ngIf="alarmIsValidable()">
      <b>{{'ALARMS_VALIDATORS'|translate}}</b>
      <br clear="left"/>
      <app-project-alarms-user-remove-list
        [alarmUsersList]="masterValidator ? masterValidator.alarmUsersList : alarmValidatorsList" [readOnly]="true"
        [validatorMode]="true"
        *ngIf="stepper._getFocusIndex() === getCheckSaveIndex() && showSpinner===false"
      ></app-project-alarms-user-remove-list>
      <br clear="left"/>
      </span>


      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-warning"
                [ngStyle]="{opacity: invalidFields && 0 < invalidFields.length ? 0.5 : 1}"
                (click)="(!invalidFields || (invalidFields && 0 === invalidFields.length)) ?
                                    saveAlarm()
                                    : signalInvalidValues()">
          <app-progressbar *ngIf="showSpinner"></app-progressbar>
          {{'SAVE' | translate}}
        </button>
      </div>
    </mat-step>


  </mat-horizontal-stepper>
</div>

<div class="modal-body formModal" *ngIf="readOnly">

  <b>{{'ALARMS_TYPE'|translate}}</b>
  <br clear="left"/>
  <mat-chip>
    {{alarmTypeSelected | translate}}
  </mat-chip>
  <mat-form-field>
    <input matInput [placeholder]="'NAME' | translate" [value]="alarmsTypeForm.value.name" required
           disabled>
  </mat-form-field>

  <div *ngIf="alarmTypeSelected === ALARM_TYPE.OPERATING">
    <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
    <br clear="left"/>
    <mat-form-field>
      <mat-select [placeholder]="'DEVICE_TYPE' | translate" required [(value)]="opParamsDeviceType"
                  disabled>
        <mat-option [value]="deviceType.id"
                    *ngFor="let deviceType of DEVICE_TYPES_FOR_ALARMS">{{deviceType.key | translate}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select [placeholder]="'STARTING_MODE' | translate" required [(value)]="opParamsStartingMode"
                  disabled>
        <mat-option [value]="'first-measure'">{{'first-measure'| translate}}</mat-option>
        <mat-option [value]=" 'init-date'">{{ 'init-date' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="date-picker" placement="bottom"
                    [ngbTooltip]="'START_DATE_TOOLTIP' | translate">
      <input matInput [(value)]="dateStart" [matDatepicker]="picker1" required disabled
             placeholder="Start">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 [startAt]="dateStart"></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="float-left">
      <mat-select [placeholder]="'REMINDER_INTERVAL' | translate" required
                  [(value)]="opParamsReminderInterval" disabled>
        <mat-option *ngFor="let reminderInterval of reminderIntervals"
                    [value]="reminderInterval.name">{{reminderInterval.value}}</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field *ngIf="opParamsDeviceType !== 1">
      <mat-select [placeholder]="'PERIOD' | translate" required [(value)]="opParamsPeriod" disabled>
        <mat-option *ngFor="let v of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]"
                    [value]="v">{{v}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle class="sliderActiveList" [(ngModel)]="opParamsActive"
                      placement="right"
                      [ngbTooltip]="'ACTIVE' | translate" disabled>{{'ACTIVE' | translate}}
    </mat-slide-toggle>
    <br clear="left"/>
  </div>
  <div *ngIf="alarmTypeSelected === ALARM_TYPE.DATA_USAGE">
    <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
    <br clear="left"/>
    <mat-form-field>
      <input matInput [placeholder]="'PERIOD_FOR_USAGE_ALARM' | translate" required [(ngModel)]="usDaysInterval"
             disabled>
    </mat-form-field>


    <mat-form-field>
      <input matInput [placeholder]="'VOLUME_MO_USAGE' | translate" required disabled
             [(ngModel)]="usMoUsage">

    </mat-form-field>

    <mat-slide-toggle [(ngModel)]="usParamsActive" disabled
                      placement="right"
                      [ngbTooltip]="'ACTIVE' | translate">{{'ACTIVE' | translate}}
    </mat-slide-toggle>
    <br clear="left"/>
  </div>
  <div *ngIf="alarmTypeSelected === ALARM_TYPE.THRESHOLD">
    <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
    <br clear="left"/>
    <mat-slide-toggle class="sliderActiveList" [(ngModel)]="low"
                      placement="right"
                      [ngbTooltip]="'LOW' | translate" disabled>{{'LOW' | translate}}
    </mat-slide-toggle>
    <mat-slide-toggle class="sliderActiveList" [(ngModel)]="medium"
                      placement="right"
                      [ngbTooltip]="'MEDIUM' | translate" disabled>{{'MEDIUM' | translate}}
    </mat-slide-toggle>
    <mat-slide-toggle class="sliderActiveList" [(ngModel)]="high"
                      placement="right"
                      [ngbTooltip]="'HIGH' | translate" disabled>{{'HIGH' | translate}}
    </mat-slide-toggle>
    <br clear="left"/>
  </div>
  <div *ngIf="alarmTypeSelected === ALARM_TYPE.CONSOLIDATED_EVENT_DYN">
    <b>{{'ALARMS_PARAM_BY_TYPE'|translate}}</b>
    <br clear="left"/>
    <mat-form-field>
      <input  matInput [placeholder]="'RANGE' | translate" [value]="event_dyn_range" required
              disabled>
    </mat-form-field>
    <mat-form-field>
      <input  matInput [placeholder]="'N_EVENTS' | translate" [value]="event_dyn_events" required
              disabled>
    </mat-form-field>
    <br clear="left"/>

  </div>
  <div *ngIf="alarmsWithGenericParams.includes(alarmTypeSelected)">
    <app-project-alarm-parameters
      readOnly="true"
      [alarmName]="alarmTypeSelected"
      [params]="alarmGenericParams"
      [projectId]="projectId"
      [invalidFieldsArray]="invalidFields"
      (next)="stepper.next()"
      (back)="stepper.previous()">
    </app-project-alarm-parameters>
  </div>

  <div *ngIf="alarmTypesWithLocations.includes(alarmTypeSelected)">
    <b>{{'ALARMS_LOCATIONS'|translate}}</b>
    <br clear="left"/>
    <app-project-alarms-location-remove-list [alarmLocationsList]="alarmLocationsList"
                                             [typeAlarm]="alarmTypeSelected"
                                             [projectId]="projectId" [readOnly]="true" *ngIf="showSpinner===false"
    ></app-project-alarms-location-remove-list>

  </div>
  <span>
  <b>{{'ALARMS_USERS'|translate}}</b>
  <br clear="left"/>
  <app-project-alarms-user-remove-list
    [alarmUsersList]="alarmUsersList" [readOnly]="true"
    *ngIf="showSpinner===false"></app-project-alarms-user-remove-list>
  <br clear="left"/>
  </span>

  <span *ngIf="alarmIsValidable()">
  <b>{{'ALARMS_VALIDATORS'|translate}}</b>
  <br clear="left"/>
  <app-project-alarms-user-remove-list
    [alarmUsersList]="alarmValidatorsList" [readOnly]="true" [validatorMode]="true"
    *ngIf="showSpinner===false"></app-project-alarms-user-remove-list>
  <br clear="left"/>
  </span>


</div>
